module.exports = __webpack_public_path__ + "media/images/block-step-2x-ec170319.png";